<template>
  <div style="display: inline-block; margin: 0; padding: 0;">
     <!--Table -->
    <el-button type="success" @click="showDialog">测量情况</el-button>
    <!--<el-button type="success">测量情况</el-button>-->

    <el-dialog title="测量情况" :visible.sync="dialogTableVisible" :modal-append-to-body="false">

      <div class="block">
        <!--<span class="demonstration">带快捷选项</span>-->
        <el-date-picker
                v-model="measureDate"
                align="right"
                type="date"
                placeholder="请选择测量日期"
                :picker-options="pickerOptions"
                @change="changeDate">
        </el-date-picker>
      </div>

      <!--<el-table :data="gridData">-->
      <!--  <el-table-column property="date" label="日期" width="150"></el-table-column>-->
      <!--  <el-table-column property="name" label="姓名" width="200"></el-table-column>-->
      <!--  <el-table-column property="address" label="地址"></el-table-column>-->
      <!--</el-table>-->

      <el-alert
              v-if="userTotalCount > 0"
              :closable="false"
              type="success">
         {{measureDate | dateFormat}}共测量{{userTotalCount}}次
      </el-alert>

      <el-alert
              v-if="userTotalCount <= 0"

              :closable="false"
              type="warning">
        {{measureDate | dateFormat}}无测量数据
      </el-alert>

      <el-table
              v-if="userTotalCount > 0"
              size="mini"
              border
              :data="gridData"
              style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
                    border
                    size="mini"
                    :data="props.row.holeCountList"
                    style="width: 100%">
              <el-table-column
                      prop="hole"
                      label="测斜孔">
              </el-table-column>
              <el-table-column
                      prop="count"
                      label="测斜孔测量次数">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
                label="测点"
                prop="point">
        </el-table-column>
        <el-table-column
                label="测点测量次数"
                prop="totalCount">
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="hideDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

  import MD5 from 'js-md5';
  export default {
    name: "UserMeasureSituation",
    data () {
      return {
        dialogTableVisible: false,
        measureDate: new Date(),
        pickerOptions: {

        },
        userTotalCount: 0,
        gridData: []
      }
    },
    methods: {
      showDialog () {
        let _this = this;
        // 显示弹框
        _this.dialogTableVisible = true;

        // 更新数据
        _this.refreshData();
      },
      hideDialog () {
        let _this = this;
        _this.dialogTableVisible = false;
      },
      changeDate () {
        let _this = this;
        _this.refreshData();
      },
      refreshData () {
        let _this = this;

        _this.gridData = [];
        _this.userTotalCount = 0;

        let hash = 'userId=' + _this.$store.state.auth_userId + '&timestamp=' + _this.$store.state.auth_timestamp + '&salt=rasberCloud';
        // front/data/measureCount?userId=349&timestamp=1593730466&auth_userId=29&auth_timestamp=1593759542710&token=627f2791b8136caf9706601cca4ce57d
        _this.$http.get('/front/data/measureCount',
          {
            params: {
              userId: _this.$store.state.userId,
              timestamp: parseInt(_this.measureDate.getTime()/1000),

              auth_userId:_this.$store.state.auth_userId,
              auth_timestamp:_this.$store.state.auth_timestamp,
              token:MD5(hash),
            },
          }
        ).then(function (res) {
          _this.responseData = res.data.data;
          if (_this.responseData !== null) {
            _this.gridData = _this.responseData.pointCountList;
            _this.userTotalCount = _this.responseData.totalCount;
          }
          // _this.responseData = {
          //   "totalCount": 20,
          //   "pointCountList": [
          //     {
          //       "point": "七号线二期加庄",
          //       "totalCount": 20,
          //       "holeCountList": [
          //         {
          //           "id": "1593651561930874",
          //           "hole": "ZQT02",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651580484592",
          //           "hole": "ZQT03",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651594165604",
          //           "hole": "ZQT04",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651608206793",
          //           "hole": "ZQT05",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651623851559",
          //           "hole": "ZQT08",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593651645725092",
          //           "hole": "ZQT10",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593651668222826",
          //           "hole": "ZQT12",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593651691517921",
          //           "hole": "TST01",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593655800981520",
          //           "hole": "ZQT11新",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593655825022932",
          //           "hole": "ZQT9 新",
          //           "count": 3
          //         }
          //       ]
          //     },
          //     {
          //       "point": "七号线二期加庄",
          //       "totalCount": 20,
          //       "holeCountList": [
          //         {
          //           "id": "1593651561930874",
          //           "hole": "ZQT02",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651580484592",
          //           "hole": "ZQT03",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651594165604",
          //           "hole": "ZQT04",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651608206793",
          //           "hole": "ZQT05",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593651623851559",
          //           "hole": "ZQT08",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593651645725092",
          //           "hole": "ZQT10",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593651668222826",
          //           "hole": "ZQT12",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593651691517921",
          //           "hole": "TST01",
          //           "count": 1
          //         },
          //         {
          //           "id": "1593655800981520",
          //           "hole": "ZQT11新",
          //           "count": 3
          //         },
          //         {
          //           "id": "1593655825022932",
          //           "hole": "ZQT9 新",
          //           "count": 3
          //         }
          //       ]
          //     }
          //   ]
          // };


          // console.log('_this.gridData',_this.gridData);
          // console.log('_this.userTotalCount',_this.userTotalCount);

        }).catch(function (res) {
          _this.$message(res.body.msg);
        })
      },
      // watch: {
      //   // measureDate: (v) => {
      //   //   let _this = this;
      //   //   if (v) {
      //   //     _this.refreshData();
      //   //   }
      //   // }
      // }
    }
  }
</script>

<style scoped>

</style>
